const getLocationStepData = locations => ({ locations: locations.nodes });

export default getLocationStepData;
